// extracted by mini-css-extract-plugin
module.exports = {"linkWrapper":"_6261581","linkInner":"_53f8bb6","linkIcon":"_0ddec37","linkText":"_e10d451"};